export const OperatorIcon = () => (
  <svg width={36} height={36} fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx={18} cy={18} r={18} fill="#40A642" />
    <path
      d="M25.866 23.848v2.98H10.133v-2.98c0-1.262.694-2.421 1.806-3.017a12.834 12.834 0 0 1 12.121 0 3.423 3.423 0 0 1 1.806 3.017Z"
      fill="#fff"
    />
    <circle cx={17.807} cy={12.31} r={4.081} fill="#fff" />
  </svg>
);
